import React from 'react';
import { withRouter } from 'next/router';
import { Button } from '@material-ui/core';
import { connect } from 'react-redux';
import {
  CaretRight,
  MapPin,
  Handshake,
  CheckCircle,
  XCircle,
} from 'phosphor-react';
import {
  SunnyKitchen,
  NearByParks,
  ReadyToHost,
  BuyExportIcon,
  MoneyIcon,
} from '../../../components/utility/Icons';
import { isMobile, isTablet } from '../../../lib/getDeviceSize';
import Reviews from '../home/Reviews';
import style from '../../../styles/sass/pages/Buy.module.scss';
import { schedulingLink } from '../../../lib/constants';
import { formatUtmParams } from '../../../lib/helpers';

export interface Props {
  router: any;
  token: string | null;
  user: any;
  utmCampaign: string;
  utmMedium: string;
  utmSource: string;
  utmTerm: string;
}

export class BuyPage extends React.Component<Props> {
  handleContactClick = () => {
    const { user, token } = this.props;
    if (token) {
      const query = formatUtmParams(this.props);
      const win: any = window.open(`${schedulingLink}${query}`, '_blank');
      win.focus();
    } else {
      const win: any = window.open(`${schedulingLink}`, '_blank');
      win.focus();
    }
  };

  openSignup = () => {
    if (this.props.token) {
      this.props.router.push({
        pathname: '/survey',
        query: {
          stage: 'info',
          part: 'basics',
          question: 'cover',
        },
      });
    } else {
      const { asPath } = this.props.router;
      const usePath = asPath.includes('/search') ? '/search' : asPath;
      this.props.router.push({
        pathname: '/signup/onboarding',
        query: {
          stage: 'intro',
          question: 'cover',
          signupPath: encodeURI(usePath),
        },
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        {/* Section Hero */}
        <section className="col-xs-12 buy-hero-banner">
          <div className="buy-container-wrap">
            <div className="buy-text-container">
              <h1 className="home-hero-heading-text">
                Home buying that’s
                <br className="no-tablet no-mobile" /> all about you
              </h1>
              <span className="home-hero-text">
                You know what you like in a home, we know how to find it. Take
                our home buying personalization quiz so that our team of local
                expert real estate agents can give you the best experience
                possible.
              </span>
              <div className={style.buyherobtnContainer}>
                <Button
                  className={`${style.baseBtn} ${style.btnLarge} ${style.startBuyButton}`}
                  size="large"
                  variant="contained"
                  onClick={this.openSignup}
                >
                  Start home buying quiz
                </Button>
                <Button
                  className={`${style.baseBtn} ${style.btnLarge} ${style.talkToUsButton}`}
                  size="large"
                  variant="contained"
                  onClick={this.handleContactClick}
                >
                  Talk to us{' '}
                  <CaretRight size={24} color="#FF7350" weight="regular" />
                </Button>
              </div>
              <div className="hero-location">
                <MapPin
                  size={22}
                  color="#FFFFFF"
                  weight="fill"
                  style={{ marginRight: 5 }}
                />
                <p style={{ color: '#FFFFFF' }}>
                  Available across all of Massachusetts
                </p>
              </div>
            </div>
            <div className="buy-hero-image">
              <img
                src={
                  isMobile()
                    ? '/static/img/landing_pages/buy-page-hero-mobile.png'
                    : '/static/img/landing_pages/buy-page-hero-desktop.png'
                }
                className="home-hero-image-two"
                alt="buy-hero-banner-one"
              />
            </div>
          </div>
          <article className="press-container">
            <a
              href="https://www.bostonglobe.com/2021/07/09/business/boston-home-buying-app-seeks-overhaul-industry-one-swipe-time/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/static/img/home/boston-globe-logo.svg"
                className="press-icon"
                alt="Boston-Globe"
              />
            </a>
            <a
              href="https://www.inman.com/2022/04/11/alternative-brokerage-torii-is-innovating-home-search-management-tech-review/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/static/img/home/inman-logo.svg"
                className="press-icon"
                alt="Inman"
              />
            </a>
            <a
              href="https://markets.businessinsider.com/news/stocks/boston-real-estate-startup-torii-expands-to-bay-area-1028813138"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/static/img/home/business-insider-logo.svg"
                className="press-icon"
                alt="Business-Insider"
              />
            </a>
          </article>
        </section>
        <img
          src={
            isMobile()
              ? '/static/img/home/hero-bottom-ellipse-mobile.svg'
              : '/static/img/home/hero-bottom-ellipse.svg'
          }
          style={{ width: '100%', marginTop: -1 }}
        />

        {/* Section Advantage */}
        <section
          className={`col-xs-12 center-xs middle-xs advantage home-advantage ${style.homeAdvantage}`}
        >
          <div
            className={`col-xs-12 advantage-home-container ${style.homeAdvantageContainer}`}
            style={{ flexDirection: 'column' }}
          >
            <div className={`advantage-header ${style.advantageHeader}`}>
              <span className={`${style.advantageHeading}`}>
                The complete home buying experience
              </span>
            </div>
            <div className="advantage-points">
              <div
                className={`advantage-point-container ${style.advantagePointContainer}`}
                style={{ backgroundColor: '#463264' }}
              >
                <BuyExportIcon
                  size={64}
                  color="#FFA0BE"
                  weight="fill"
                  className={style.advantageIcon}
                />
                <h4
                  className={`advantage-point-heading ${style.advantagePointheading}`}
                  style={{ color: '#FFFFFF', minHeight: 'auto' }}
                >
                  Expert local agents
                </h4>
                <span className="advantage-point-text">
                  Our team will be by your side through every showing, offer,
                  negotiation and late-night phone call, to make sure you’re as
                  competitive as possible and find your perfect place.
                </span>
              </div>
              <div
                className={`advantage-point-container ${style.advantagePointContainer}`}
                style={{ backgroundColor: '#195A50' }}
              >
                <Handshake
                  size={64}
                  color="#FFD750"
                  weight="fill"
                  className={style.advantageIcon}
                />
                <h4
                  className={`advantage-point-heading ${style.advantagePointheading}`}
                  style={{ color: '#FFFFFF', minHeight: 'auto' }}
                >
                  Real estate dream team
                </h4>
                <span className="advantage-point-text">
                  Everything you’ll need to get from your first search through
                  move-in day. Agent, lender, title insurance, appraiser,
                  closing servies, a full support team, and seamless tech to
                  supercharge your home buying experience.
                </span>
              </div>
              <div
                className={`advantage-point-container ${style.advantagePointContainer}`}
                style={{ backgroundColor: '#822841' }}
              >
                <MoneyIcon
                  size={64}
                  color="#FF7350"
                  weight="fill"
                  className={style.advantageIcon}
                />
                <h4
                  className={`advantage-point-heading ${style.advantagePointheading}`}
                  style={{ color: '#FFFFFF', minHeight: 'auto' }}
                >
                  Real savings
                </h4>
                <span className="advantage-point-text">
                  Real estate commissions are too damn high, so when you buy a
                  home with us, we’ll give you up to 10% of ours back at close.
                  That’s thousands of dollars in your pocket. Treat yourself!
                </span>
              </div>
            </div>
          </div>
        </section>

        {/*Section Personalization*/}
        <section
          className={`col-xs-12 ${style.featuredImage_block} ${style.toriiPlum_bg} ${style.coverSticker_block}`}
        >
          <div className={style.container_wrap}>
            <div className={style.text_container}>
              <span className={style.heading}>Personalization</span>
              <span className={style.subHeading}>Tell us about yourself</span>
              <span className={style.mainText}>
                We want to get to know who you are and what you’re really
                looking for. Take our home buying personalization quiz to kick
                start your home search and get connected with one of our expert
                local agents.
              </span>
              <div className={style.buyherobtnContainer}>
                <Button
                  className={`${style.baseBtn} ${style.btnLarge} ${style.startBuyButton}`}
                  size="large"
                  variant="contained"
                  onClick={this.openSignup}
                >
                  Start home buying quiz
                </Button>
                <Button
                  className={`${style.baseBtn} ${style.btnLarge} ${style.talkToUsButton}`}
                  size="large"
                  variant="contained"
                  onClick={this.handleContactClick}
                >
                  Talk to us{' '}
                  <CaretRight size={24} color="#FF7350" weight="regular" />
                </Button>
              </div>
            </div>
            <div
              className={`${style.imageWrap} ${style.imageBg} ${style.buyPersonalizeImageBg}`}
            >
              {(isTablet() || isMobile()) && (
                <img
                  src="/static/img/landing_pages/buy-page-move-in-mobile.png"
                  className={style.feturedImage}
                  alt="buy personalized"
                />
              )}
              <div className={style.coverStickerBase}>
                <span className={style.SunnyKitchenSticker}>
                  <SunnyKitchen />
                </span>
                <span className={style.NearByParksSticker}>
                  <NearByParks />
                </span>
                <span className={style.ReadyToHostSticker}>
                  <ReadyToHost />
                </span>
              </div>
            </div>
          </div>
        </section>

        {/*Section Alternate Image with Text block*/}
        <section className="col-xs-12 altImageText_block">
          <div className="container_wrap">
            <div className="feature_block topAlign">
              <div className="row">
                <span className="header-text">All-in-one team</span>
                <span className="sub-text">
                  Meet your real estate <br className="no-desktop no-mobile" />{' '}
                  dream team <br />
                </span>
                <span className="text">
                  We provide you a complete team of real estate specialists to
                  keep you on track and ahead of the competition:
                </span>
                <ul className={style.checkCircle_listing}>
                  <li>
                    <CheckCircle color="#195A50" size={24} weight="fill" /> Real
                    estate agent
                  </li>
                  <li>
                    <CheckCircle color="#195A50" size={24} weight="fill" />{' '}
                    Lender
                  </li>
                  <li>
                    <CheckCircle color="#195A50" size={24} weight="fill" />{' '}
                    Insurance
                  </li>
                  <li>
                    <CheckCircle color="#195A50" size={24} weight="fill" />{' '}
                    Appraiser
                  </li>
                  <li>
                    <CheckCircle color="#195A50" size={24} weight="fill" />{' '}
                    Inspector
                  </li>
                  <li>
                    <CheckCircle color="#195A50" size={24} weight="fill" />{' '}
                    Experience manager
                  </li>
                </ul>
              </div>
              <div className="image_wrap">
                <img
                  src={
                    isMobile()
                      ? '/static/img/landing_pages/buy-page-dream-team-mobile.png'
                      : '/static/img/landing_pages/buy-page-dream-team-desktop.png'
                  }
                  alt="team"
                />
              </div>
            </div>
            {/* Savings */}
            <div className="feature_block reverse bottomAlign">
              <div className="row">
                <span className="header-text">Savings</span>
                <span className="sub-text">
                  Save thousands for
                  <br className="no-desktop no-mobile" /> the things that
                  <br className="no-desktop no-mobile" /> matter
                </span>
                <span className="text">
                  When you buy a home, we’ll give you back up to 10% of the
                  commission we receive. That’s putting our money where our
                  mouth is.
                </span>
              </div>
              <div className="image_wrap">
                <img
                  src={
                    isMobile()
                      ? '/static/img/landing_pages/buy-page-savings-mobile.png'
                      : '/static/img/landing_pages/buy-page-savings-desktop.png'
                  }
                  alt="svings"
                />
              </div>
            </div>
          </div>
        </section>

        {/*Section Home Dashboard */}
        <section className="col-xs-12 altImageText_block fullWidth_block">
          <div className="container_wrap">
            <div className="feature_block">
              <div className="row">
                <span className="header-text">Home Dashboard</span>
                <span className="sub-text">Manage your entire process</span>
                <span className="text">
                  We know searching for a home can feel overwhelming, so we
                  built a seamless dashboard to help you manage everything and
                  stay organized. Discover listings, save favorites, and
                  schedule showings - all in one place.
                </span>
              </div>
              <div className="image_wrap">
                <img
                  src={
                    isMobile()
                      ? '/static/img/landing_pages/dashboard-mobile.png'
                      : '/static/img/landing_pages/dashboard-desktop.png'
                  }
                  alt="dashboard"
                />
              </div>
            </div>
          </div>
        </section>

        {/*Section Experience*/}
        <section
          className={`col-xs-12 ${style.featuredImage_block} ${style.merlot_bg} ${style.reverse}`}
        >
          <div className={style.container_wrap}>
            <div className={style.text_container}>
              <span className={style.heading}>Experience</span>
              <span className={style.subHeading}>
                We’re going to blow your mind
              </span>
              <span className={style.mainText}>
                You’re not just a number to us. We’ll personalize your home
                buying experience and make sure you have an incredible time from
                the moment we meet you through years after you move in. From
                personalized gifts and social events, to our famous Move-in
                Survival Kit - you’ll always be a part of the Torii community.
              </span>
            </div>
            <div
              className={`${style.imageWrap} ${style.imageBg} ${style.buyExperienceImageBg}`}
            >
              {(isTablet() || isMobile()) && (
                <img
                  src="/static/img/landing_pages/buy-page-experience-mobile.png"
                  className={style.feturedImage}
                  alt="buy experience"
                />
              )}
            </div>
          </div>
        </section>

        {/*Section Why Torii*/}
        <section className="col-xs-12 reasoning">
          <div className="reasoning-container">
            <h1>Why Torii?</h1>
            <article className="reasons">
              <div
                className="reason"
                style={{
                  margin: '20px 0px 0px 0px',
                  backgroundColor: 'transparent',
                }}
              >
                <span className="reason-text no-mobile">&nbsp;</span>
                <h6 className="column-one">Torii</h6>
                <h6 className="column-two no-desktop">Others</h6>
                <h6 className="column-two no-mobile no-tablet">
                  Traditional Brokerage
                </h6>
              </div>
              <div className={`reason ${style.reasonIcon}`}>
                <span className="reason-text">
                  Get back up to 10% of our commission
                </span>
                <span className="column-one">
                  <CheckCircle size={40} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={40} color="#822841" weight="fill" />
                </span>
              </div>
              <div className={`reason ${style.reasonIcon}`}>
                <span className="reason-text">
                  Highly-vetted real estate agents
                </span>
                <span className="column-one">
                  <CheckCircle size={40} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={40} color="#822841" weight="fill" />
                </span>
              </div>
              <div className={`reason ${style.reasonIcon}`}>
                <span className="reason-text">Unmatched client experience</span>
                <span className="column-one">
                  <CheckCircle size={40} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={40} color="#822841" weight="fill" />
                </span>
              </div>
              <div className={`reason ${style.reasonIcon}`}>
                <span className="reason-text">
                  Lender, insurance, and more all provided
                </span>
                <span className="column-one">
                  <CheckCircle size={40} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={40} color="#822841" weight="fill" />
                </span>
              </div>
              <div className={`reason ${style.reasonIcon}`}>
                <span className="reason-text">
                  All-in-one home buying technology
                </span>
                <span className="column-one">
                  <CheckCircle size={40} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={40} color="#822841" weight="fill" />
                </span>
              </div>
              <div className={`reason ${style.reasonIcon}`}>
                <span className="reason-text">
                  Personalized gifts and experiences
                </span>
                <span className="column-one">
                  <CheckCircle size={40} color="#195A50" weight="fill" />
                </span>
                <span className="column-two">
                  <XCircle size={40} color="#822841" weight="fill" />
                </span>
              </div>
            </article>
          </div>
          <div className="get-started-button-container">
            <a
              className={`${style.baseBtn} ${style.baseBtnPineGreen}`}
              href="#"
              rel="noopener noreferrer"
              onClick={this.openSignup}
            >
              Start home buying quiz
            </a>
            <a
              className={`${style.baseBtn} ${style.talkToUsBorder}`}
              href="/contact"
              rel="noopener noreferrer"
            >
              Talk to us{' '}
              <CaretRight size={24} color="#195A50" weight="regular" />
            </a>
          </div>
        </section>

        {/*Section Testimonials*/}
        <section className="col-xs-12 testimonials">
          <div
            className="reviews-header-container"
            style={{ marginBottom: '24px' }}
          >
            <span className="blue-blob" />
            <span className="yellow-blob" />
          </div>
          <Reviews autoSlide={true} title="Take their word for it" />
        </section>

        <section className="col-xs-12 video-container">
          <iframe
            width={isMobile() ? 750 : 750}
            height="420"
            src="https://www.youtube.com/embed/x3Q3QBGWj_4?si=siX9uTAhAu7lScy4"
            title="We Are Torii Homes"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </section>

        {/*Section Search */}
        <section className="col-xs-12 altImageText_block pineGreen_bg fullWidth_block">
          <div className="container_wrap">
            <div className="feature_block">
              <div className="row">
                <span className={`sub-text ${style.sunshineColor}`}>
                  Home search that really gets you
                </span>
                <span className="text">
                  Get straight to what you want with curated listing
                  recommendations powered by AI. Is cooking your thing? See the
                  kitchen first. Love to host? Only see homes with great living
                  rooms and outdoor space.
                </span>
                <a
                  className={`${style.baseBtn} ${style.pineGreen_txt}`}
                  style={{ marginTop: '30px' }}
                  href="/search-homes"
                  rel="noopener noreferrer"
                >
                  Learn More
                </a>
              </div>
              <div className="image_wrap">
                <img
                  src={
                    isMobile()
                      ? '/static/img/landing_pages/search-page-hero-mobile.png'
                      : '/static/img/landing_pages/search-page-hero-desktop.png'
                  }
                  alt="search homes"
                />
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  token: state.auth.token,
  user: state.auth.user,
  utmCampaign: state.auth.utmCampaign,
  utmMedium: state.auth.utmMedium,
  utmSource: state.auth.utmSource,
  utmTerm: state.auth.utmTerm,
});

export default connect(mapStateToProps)(withRouter(BuyPage));
